import { pathJoin } from 'src/reducers/routing/utils'

export const createExportsDetailViewRoutesMap = (prefix: string) => ({
  overview: pathJoin(prefix)('overview').chain,
  settings: pathJoin(prefix)('settings').chain,
})
